const INITIAL = {
  userData: {},
  isNew: false,
  isConfirmed: false,
  isUnconfirmed: false,
  isPending: false,
  temp: {},
  user: JSON.parse(localStorage.getItem("user")) || {
    firstName: "",
    lastName: "",
    countryCode: "",
    phone: "",
    address: "",
    city: "",
    email: ""
  },
  redirectUrl: {
    pathName: "",
    query: []
  },
  loginFetching: false,
  loginFetched: false,
  loginError: null,
  forgotPasswordPending: false,
  forgotPassword: null,
  forgotPasswordVerify: null,
  changePasswordResult: {
    status: null,
    error: null,
    response: ""
  },
  isLoggedIn: false,
  ressetPass: false,
  error: {},
  me: null
};

export default function reducer(state = INITIAL, action) {
  switch (action.type) {
    case "FETCH_USER_PENDING": {
      state = Object.assign({}, state, {
        loginFetching: true,
        loginFetched: false
      });
      break;
    }

    case "USER_GET_ME": {
      state = Object.assign({}, state, {
        me: action.data
      });
      break;
    }

    case "FETCH_USER_FULFILLED": {
      localStorage.setItem("userToken", action.payload.token);
      localStorage.setItem("user", JSON.stringify(action.payload));
      state = Object.assign({}, state, {
        //user: action.payload,
        isLoggedIn: true,
        loginFetching: false,
        loginFetched: true,
        error: null
      });
      break;
    }

    case "RESSET_LOGIN_ERRORS": {
      state = Object.assign({}, state, {
        //user: action.payload,
        loginFetching: false,
        loginFetched: false,
        error: null
      });
      break;
    }

    case "SET_USER_STATE": {
      state = Object.assign({}, state, { isLoggedIn: action.payload });
      break;
    }

    case "SET_USER_LOGOUT": {
      state = Object.assign({}, state, { isLoggedIn: false, user: {} });
      break;
    }
    case "FORGOT_PASSWORD_PENDING": {
      state = Object.assign({}, state, {
        forgotPasswordPending: true,
        forgotPassword: null,
        forgotPasswordVerify: null
      });
      break;
    }
    case "FORGOT_PASSWORD_RESOLVE": {
      state = Object.assign({}, state, {
        forgotPasswordPending: false,
        forgotPassword: action.payload
      });
      break;
    }
    case "FORGOT_PASSWORD_REJECT": {
      state = Object.assign({}, state, {
        forgotPasswordPending: false,
        forgotPassword: action.error
      });
      break;
    }

    case "NEW_PASSWORD_VERIFY_PENDING": {
      state = Object.assign({}, state, {
        forgotPasswordPending: true,
        forgotPasswordVerify: null
      });
      break;
    }
    case "NEW_PASSWORD_VERIFY_RESOLVE": {
      state = Object.assign({}, state, {
        forgotPasswordPending: false,
        forgotPasswordVerify: action.payload
      });
      break;
    }
    case "NEW_PASSWORD_VERIFY_REJECT": {
      state = Object.assign({}, state, {
        forgotPasswordPending: false,
        forgotPasswordVerify: action.error
      });
      break;
    }
    case "FETCH_USER_REJECTED": {
      localStorage.removeItem("userToken");
      state = Object.assign({}, state, {
        isLoggedIn: false,
        loginFetching: false,
        loginFetched: false,
        error: action.error
      });
      break;
    }

    case "RESSET_PASS": {
      state = Object.assign({}, state, {
        ressetPass: true,
        user: action.payload,
        isLoggedIn: false
      });
      break;
    }

    case "IS_LOGGEDIN": {
      state = Object.assign({}, state, { isLoggedIn: true });
      break;
    }
    case "CHANGE_PASSWORD_PENDING": {
      state = Object.assign({}, state, {
        error: null,
        changePasswordResult: { status: "pending", response: "" }
      });
      break;
    }
    case "CHANGE_PASSWORD_RESOLVE": {
      state = Object.assign({}, state, {
        error: null,
        changePasswordResult: {
          status: "success",
          response: "You have successfully changed your password."
        }
      });
      break;
    }
    case "CHANGE_PASSWORD_REJECT": {
      state = Object.assign({}, state, {
        error: action.error,
        changePasswordResult: { status: "error", error: action.error }
      });
      break;
    }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/userReducer.js